import { ReactNode } from 'react';

// import { Box } from '@chakra-ui/react';

import * as Components from 'view-layer/components';
// import * as Html from 'view-layer/styled/html';

import { PaymentData } from 'business-layer/types';
// import { L10nContext } from 'business-layer/contexts/L10nContext';
import { PropertyInfo } from 'view-layer/components/layout/info/PropertyInfo';
// import { PropertyReservation } from 'view-layer/components/layout/info/PropertyReservation';
// import { PropertyAmount } from 'view-layer/components/layout/info/PropertyAmount';

interface InfoPanelProps {
  children?: ReactNode
  payment: any,
  full?: boolean,
}

export const InfoPanel: React.FC<InfoPanelProps> = ({ children, payment, full = true}) => {
  // const { labels }: { labels: GenericKeyValue } = useContext(L10nContext) as any;

  const cityLine = ((data: PaymentData): string => {
    const line = [];
    if (data.city) {
      line.push(data.city);
    }
    if (data.state || data.zip) {
      line.push(', ');
    }
    if (data.state) {
      line.push(data.state);
    }
    if (data.zip) {
      line.push(' ');
      line.push(data.zip);
    }
    return line.join('').trim();
  })(payment);

  const propInfoData = {...payment, city: cityLine };

  // const lowerBoxStyles = (!full || children) ? {
  //   bgColor: 'white',
  //   height: '100%',
  // } : {
  //   bgColor: 'transparent',
  //   padding: 0,
  // };

  return (
    <Components.Layout.Panel variant="dark" key="1">
      <PropertyInfo data={propInfoData} />
    </Components.Layout.Panel>
  );
}
